import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { TimesheetAccessService } from '../components/timesheet-mangement/timesheet-access.service';

/**
 * Blocks Timesheet Report when the feature flag is off or the user lacks
 * Timesheet Report permission (submodule 49 / manage).
 */
export const timesheetReportGuard: CanActivateFn = () => {
  const router = inject(Router);
  const timesheetAccess = inject(TimesheetAccessService);
  timesheetAccess.refresh();
  if (timesheetAccess.canOpenTimesheetReport()) {
    return true;
  }
  const fallback = timesheetAccess.firstAccessibleChildPath('report');
  if (fallback) {
    return router.createUrlTree(['/dashboard', 'timesheet', fallback]);
  }
  return router.createUrlTree(['/dashboard', 'home']);
};
